import styled from "styled-components";

export const ChatContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  min-width: 70%;
  min-height: 80vh;
  max-height: 80vh;
  position: relative;
  padding-top: 1em;
`;

export const ChatBox = styled.div`
  display: inline-block;
  overflow-y: auto;
  max-height: 60vh;

  @media only screen and (max-width: 700px) {
    max-height: 55vh;
  }
`;

export const ChatSender = styled.h3`
  color: #d0021b;
  font-weight: bold;
  margin-bottom: 0;

  @media only screen and (max-width: 520px) {
    font-size: 1em;
  }
`;

export const Chat = styled.h5`
  color: white;
  margin-bottom: 2rem;
  @media only screen and (max-width: 520px) {
    font-size: 0.75em;
  }
`;

export const Notification = styled.h5`
  color: yellow;
  margin-bottom: 2rem;
  @media only screen and (max-width: 520px) {
    font-size: 0.75em;
  }
`;

export const ChatControlContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  padding-bottom: 3em;
  padding-right: 3em;

  @media only screen and (max-width: 520px) {
    padding-right: 0;
  }
`;

export const MessageBox = styled.input`
  transition-duration: 0.2s;
  font-size: 1.25em;
  font-weight: 700;
  background-color: #636363;
  border: none;
  text-align: center;
  padding: 0.5em;
  margin-right: 0.5em;
  border-radius: 16px;
  height: 1.5em;
  width: 35em;
  &::placeholder {
    color: darkgray;
  }
  &:focus {
    border: 2px;
    border-color: white;
    background-color: lightgray;
    color: black;
    outline: none;
  }
  &:disabled {
    cursor: default;
  }

  @media only screen and (max-width: 1370px) {
    flex: 1;
  }

  @media only screen and (max-width: 520px) {
    flex-flow: column wrap;
    align-items: center;
    margin-right: 0;
    font-size: 1.125em;
  }

  @media only screen and (max-width: 375px) {
    font-size: 1em;
  }
`;

export const Button = styled.button`
  outline: none;
  cursor: pointer;
  transition-duration: 0.1s;
  border: none;
  font-weight: 700;
  background-color: #b80016;
  color: white;
  margin: 0.5em;
  width: 10em;
  height: 2.5em;
  border-radius: 16px;
  &:disabled {
    cursor: default;
    background-color: #969696;
    color: #c7c7c7;
  }
  &:hover:enabled {
    background-color: #ff001f;
    box-shadow: 0 2px 3px #999;
  }
  &:active:enabled {
    box-shadow: 0 0px 2px #666;
    background-color: #ff001f;
    transform: translateY(1px);
  }

  @media only screen and (max-width: 1370px) {
    width: 7em;
  }

  @media only screen and (max-width: 500px) {
    width: 8.5em;
    height: 2.25em;
    font-size: 1em;
  }

  @media only screen and (max-width: 375px) {
    width: 8.25em;
    height: 2.125em;
    font-size: 0.9em;
  }
`;
